import { c as _c } from "react/compiler-runtime";
import MainComponent from 'modules/main/components/main';
import { MainLoco } from 'modules/main/constants/main-loco';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Loader } from 'shared/components/loader';
import useUser from 'shared/hooks/use-user';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const Main: NextPage = () => {
  const $ = _c(7);
  const router = useRouter();
  const {
    isLoading,
    isWsAssistant
  } = useUser();
  let t0;
  let t1;
  if ($[0] !== isWsAssistant || $[1] !== router) {
    t0 = () => {
      if (isWsAssistant) {
        router.replace("/funnels");
      }
    };
    t1 = [router, isWsAssistant];
    $[0] = isWsAssistant;
    $[1] = router;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== isLoading || $[5] !== isWsAssistant) {
    t2 = isLoading || isWsAssistant ? <div className="flex justify-center"><Loader /></div> : <MainComponent />;
    $[4] = isLoading;
    $[5] = isWsAssistant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const getServerSideProps = getBaseServerSideProps(MainLoco);
export default Main;